import React from 'react'
import Page from '../components/Page'
import Typography from '../components/Typography'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import { MdEdit, MdFormatListBulleted, MdFlag, MdLanguage, MdHome, MdAdd, MdCameraAlt, MdDone, MdClear, MdFilterList, MdCreate, MdDelete } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import PosMembershipTierForm from '../components/PosMembershipTierForm'
import PosMembershipPromoForm from '../components/PosMembershipPromoForm'
import PosScheduleModForm from '../components/PosScheduleModForm'
import PosScheduleSlotDayForm from '../components/PosScheduleSlotDayForm'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'

const promo_column = [
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Code',
    field: 'promo_code',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'promo_type',
    sort: 'asc',
  },
  {
    label: 'Start',
    field: 'start_date',
    sort: 'asc',
  },
  {
    label: 'End',
    field: 'end_date',
    sort: 'asc',
  },
  {
    label: 'Tier Applied',
    field: 'tier_name',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

const membership_store_column = [
  {
    label: 'Store Code',
    field: 'store_code',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'store_type',
    sort: 'asc',
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Location',
    field: 'location',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class PosMembershipDetailPage extends React.Component {
  access = StorageService.getSession('user_access')
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isGlobal: true,
      // isStore: this.props.history.location.state.isStore,
      //role: this.props.history.location.state.store_id ? this.access.store.find(x => x.store_id == this.props.history.location.state.store_id).role : '',
      isEdit: false,
      tierConfirmModal: false,
      promoConfirmModal: false,
      promoDetailModal: false,
      storeModal: false,
      storeConfirmModal: false,
      tierModal: false,
      promoModal: false,
      redirect: false,
      selectedId: '',
      selectedData: '',
      selectedType: '',
      name: '',
      member_type: '',
      accumulation: '',
      start_date: '',
      end_date: '',
      membership_tier: [],
      membership_promo: [],
      membership_store: [],
      promoList: [],
      selected_promo: {},
      selected_store_id: '',
      storeList: [],
    }
  }

  componentDidMount() {
    this.getMembershipDetail()
    this.getPromo()
    this.getStoreList()
    this.getMembershipStore()
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  toggletier =
    (action, id, type = null) =>
    () => {
      return this.setState({
        tierModal: !this.state.tierModal,
        isEdit: id != null && action == 'EDIT' ? true : false,
        selectedId: id,
        selectedType: type,
      })
    }

  togglepromo =
    (action, id, type = null) =>
    () => {
      return this.setState({
        promoModal: !this.state.promoModal,
        isEdit: id != null && action == 'EDIT' ? true : false,
        selectedId: id,
        selectedType: type,
      })
    }

  togglestore =
    (action, id, type = null) =>
    () => {
      return this.setState({
        storeModal: !this.state.storeModal,
        // isEdit: id != null && action == 'EDIT' ? true : false,
        // selectedId: id,
        // selectedType: type,
      })
    }

  togglepromodetail = promo_code => () => {
    let selected_promo = this.state.promoList.find(x => x.promo_code == promo_code)

    return this.setState({
      promoDetailModal: !this.state.promoDetailModal,
      selected_promo: selected_promo,
    })
  }

  toggleTierConfirmModal = (name, id) => () => {
    return this.setState({
      tierConfirmModal: !this.state.tierConfirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  togglePromoConfirmModal = (name, tier_id, promo_id) => () => {
    return this.setState({
      promoConfirmModal: !this.state.promoConfirmModal,
      selectedData: name,
      selectedId: tier_id,
      selectedPromoId: promo_id,
    })
  }

  toggleStoreConfirmModal = remove_store_id => () => {
    return this.setState({
      storeConfirmModal: !this.state.storeConfirmModal,
      remove_store_id: remove_store_id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      tierModal: false,
      promoModal: false,
      promoConfirmModal: false,
      tierConfirmModal: false,
      storeConfirmModal: false,
      storeModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getMembershipDetail()
    }
  }

  getStoreList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')

    // console.log(access);
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        let storeList = result.data.filter(x => !this.state.membership_store.some(y => x.store_code == y.store_code))

        if (this._isMounted) {
          this.setState({
            storeList: storeList,
            // isLoading: false,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getPromo = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/promo', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            promoList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getMembershipDetail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const membership_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      id: membership_id,
    }

    axios
      .post(url + ':3001/v1/membership/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        for (let i of result.data.membership_promo) {
          i.Action = (
            <div className="ps-action-button">
              <Button className="theme-button theme-button-secondary" onClick={this.togglepromodetail(i.promo_code)}>
                View
              </Button>
              <Button className="theme-button theme-button-primary-light" onClick={this.togglePromoConfirmModal(i.tier_name, i.applied_tier, i.id)}>
                Remove
              </Button>
            </div>
          )
        }

        this.setState({
          membership_id: membership_id,
          name: result.data.name,
          member_type: result.data.member_type,
          accumulation: result.data.accumulation,
          start_date: result.data.start_date,
          end_date: result.data.end_date,
          membership_tier: result.data.membership_tier,
          membership_promo: result.data.membership_promo,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  getMembershipStore = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const membership_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: membership_id,
    }

    axios
      .post(url + ':3001/v1/membership/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        for (let i of result.data) {
          i.Action = (
            <div className="ps-action-button">
              <Button className="theme-button theme-button-primary-light" onClick={this.toggleStoreConfirmModal(i.id)}>
                Remove
              </Button>
            </div>
          )
        }

        this.setState({
          membership_store: result.data,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  addMembershipTier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const membership_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: 3,
      tier_name: this.state.tier_name,
      entry_level: this.state.tier_entry_level,
      points_type: this.state.points_type,
      max_points: this.state.max_points,
      conversion_rate: this.state.conversion_rate,
      max_claim: this.state.max_claim,
      min_claim: this.statte.min_claim,
      tier_unit: this.state.tier_unit,
      expiry_duration: this.state.expiry_duration,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Membership tier added successfully.',
          level: 'error',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
      })

      .catch(error => {
        alert(error)
      })
  }

  deleteTier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: this.state.membership_id,
      tier_id: this.state.selectedId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Membership Tier deleted successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ tierConfirmModal: false })
        this.getMembershipDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  deletePromo = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      membership_id: this.state.membership_id,
      tier_id: this.state.selectedId,
      promo_id: this.state.selectedPromoId,
      remove_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/promo/remove', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Membership Promo removed successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ promoConfirmModal: false })
        this.getMembershipDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  removeMembershipStore = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      membership_id: this.state.membership_id,
      store_id: this.state.remove_store_id,
      remove_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/store/remove', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Membership Store removed successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ storeConfirmModal: false })
        this.getMembershipStore()
        this.getStoreList()
      })
      .catch(error => {
        alert(error)
      })
  }

  addMembershipStore = event => {
    event.preventDefault()

    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.selected_store_id,
      membership_id: this.state.membership_id,
      added_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/store/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Membership added to store successfully.', 'success', false)
        this.getMembershipStore()
        this.getStoreList()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    const promo_data = {
      columns: promo_column,
      rows: this.state.membership_promo,
    }

    const membership_store_data = {
      columns: membership_store_column,
      rows: this.state.membership_store,
    }

    return (
      <Page
        className="PosMembershipDetailPage"
        title="Membership Detail"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posstore' },
          { name: 'Membership Detail', active: true, path: '' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Membership</CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={2}>
                    <Label>Membership Name</Label>
                    <p>{this.state.name}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Membership Type</Label>
                    <p>{this.state.member_type}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Accumulation</Label>
                    <p>{this.state.accumulation}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Start Date</Label>
                    <p>{this.state.start_date}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>End Date</Label>
                    <p>{this.state.end_date}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Membership Store</Typography>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.togglestore('ADD', null)}>
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>
                <MDBDataTableV5 className="ps-order-table th-5" data={membership_store_data} displayEntries={false} searching={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Membership Tier</Typography>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.toggletier('ADD', null)}>
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table className="ps-table tb-col-10 th-no-wrap ps-responsive-table">
                  <Thead>
                    <Tr>
                      <Th>Name</Th>
                      <Th>Points Type</Th>
                      <Th>Entry Level</Th>
                      <Th>Max Points</Th>
                      <Th>Conversion Unit</Th>
                      <Th>Conversion Rate</Th>
                      <Th>Maximum Claim Points</Th>
                      <Th>Minimum Claim Points</Th>
                      <Th>Expiry Duration</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {this.state.membership_tier.length < 1 && (
                      <Tr>
                        <Td colSpan="10">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>Click the Add button to add new tier</span>
                            </div>
                          </div>
                        </Td>
                      </Tr>
                    )}

                    {this.state.membership_tier.length > 0 &&
                      this.state.membership_tier.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Tr key={item.id}>
                              <Td>{item.tier_name}</Td>
                              <Td>{item.points_type}</Td>
                              <Td>{item.entry_level}</Td>
                              <Td>{item.max_points}</Td>
                              <Td>{item.tier_unit}</Td>
                              <Td>{item.conversion_rate}</Td>
                              <Td>{item.max_claim}</Td>
                              <Td>{item.min_claim}</Td>
                              <Td>{item.expiry_duration}</Td>
                              <Td>
                                <div className="ps-action-button">
                                  <Button className="theme-button theme-button-secondary" onClick={this.toggletier('EDIT', item.id)}>
                                    Edit
                                  </Button>
                                  <Button className="theme-button theme-button-primary-light" onClick={this.toggleTierConfirmModal(item.tier_name, item.id)}>
                                    Delete
                                  </Button>
                                </div>
                              </Td>
                            </Tr>
                          </React.Fragment>
                        )
                      })}
                  </Tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Membership Promo</Typography>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.togglepromo('ADD', null)}>
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>
                <MDBDataTableV5 className="ps-order-table th-9" data={promo_data} displayEntries={false} searching={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <Modal isOpen={this.state.tierModal} toggle={this.toggletier()} className={this.props.className} centered>
          <PosMembershipTierForm history={this.props.history} onToggleModal={this.toggletier} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.promoModal} toggle={this.togglepromo()} className={this.props.className} centered>
          <PosMembershipPromoForm history={this.props.history} onToggleModal={this.togglepromo} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        {this.state.promoDetailModal && (
          <Modal isOpen={this.state.promoDetailModal} toggle={this.togglepromodetail()} className={this.props.className} centered>
            <Form className="AuthForm">
              <ModalHeader toggle={this.togglepromodetail()}>Promo Detail</ModalHeader>
              <ModalBody>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label>Name</Label>
                      <Input type="text" name="name" value={this.state.selected_promo.name} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Promo Code</Label>
                      <Input type="text" name="promo_code" value={this.state.selected_promo.promo_code} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Promo Type</Label>
                      <Input type="text" name="promo_type" value={this.state.selected_promo.promo_type} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Option</Label>
                      <Input type="text" name="options" value={this.state.selected_promo.options} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Mod Value</Label>
                      <Input type="text" name="mod_value" value={this.state.selected_promo.mod_value} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Compare Type</Label>
                      <Input type="text" name="compare_type" value={this.state.selected_promo.compare_type} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Compare Value</Label>
                      <Input type="text" name="compare_value" value={this.state.selected_promo.compare_value} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Start Date</Label>
                      <Input type="date" name="start_date" value={this.state.selected_promo.start_date} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>End Date</Label>
                      <Input type="date" name="end_date" value={this.state.selected_promo.end_date} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Issue Limit (0 equal no limit)</Label>
                      <Input type="text" name="issue_limit" value={this.state.selected_promo.issue_limit} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label>Claim Limit (0 equal no limit)</Label>
                      <Input type="text" name="claim_limit" value={this.state.selected_promo.claim_limit} readOnly />
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
            </Form>
          </Modal>
        )}

        <Modal isOpen={this.state.storeModal} toggle={this.togglestore()} className={this.props.className} centered>
          <Form className="AuthForm" onSubmit={this.addMembershipStore}>
            <ModalHeader toggle={this.togglestore()}>Membership Store</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Store</Label>
                    <Input type="select" name="selected_store_id" value={this.state.selected_store_id} onChange={this.changeHandler} required>
                      <option value=""></option>
                      {this.state.storeList.length > 0 &&
                        this.state.storeList.map(item => {
                          return (
                            <option key={item.store_id} value={item.store_id}>
                              {item.name}
                            </option>
                          )
                        })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.tierConfirmModal} toggle={this.toggleTierConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleTierConfirmModal()}>Delete Membership Tier</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete this tier?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleTierConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.deleteTier()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.promoConfirmModal} toggle={this.togglePromoConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.togglePromoConfirmModal()}>Remove Membership Promo</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove this promo?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.togglePromoConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.deletePromo()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.storeConfirmModal} toggle={this.toggleStoreConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleStoreConfirmModal()}>Remove Membership Store</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove membership from this store?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleStoreConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.removeMembershipStore()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </Page>
    )
  }
}

export default PosMembershipDetailPage
